/** Short-lived session storage for signup password (used once to register then send invites). */
export const ONBOARDING_CREDENTIALS_KEY = 'symphony_onboarding_credentials';

export function saveOnboardingCredentials({ password, password_confirmation }) {
  sessionStorage.setItem(
    ONBOARDING_CREDENTIALS_KEY,
    JSON.stringify({ password, password_confirmation }),
  );
}

export function loadOnboardingCredentials() {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_CREDENTIALS_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o?.password || !o?.password_confirmation) return null;
    return o;
  } catch {
    return null;
  }
}

export function clearOnboardingCredentials() {
  sessionStorage.removeItem(ONBOARDING_CREDENTIALS_KEY);
}
